const Projects = [
  {
    heading: "Url_Shortener",
    description: "An URL shortening service using Express, Ejs and Mongoose",
    imageName: "UrlShortener",
    demoUrl: "https://short-11.herokuapp.com/",
    gitUrl: "https://github.com/Ishaan-11/url-shortener",
  },
  {
    heading: "BMI_Calculator",
    description:
      "React app to calculate the BMI. It can store the data for 7 days using LocalStorage.",
    imageName: "Bmi",
    demoUrl: "https://ishaan11-bmi-calculator.netlify.app/",
    gitUrl: "https://github.com/Ishaan-11/bmi-calculator",
  },
  {
    heading: "Hangman",
    description:
      "Select a letter to figure out a hidden word in a set amount of chances.",
    imageName: "hangman",
    demoUrl: "https://ishaan-11.github.io/hangman",
    gitUrl: "https://github.com/Ishaan-11/hangman",
  },
  {
    heading: "Breakout_Game",
    description:
      "Game where you control a paddle with arrow keys to bounce a ball up to break bricks.",
    imageName: "breakout",
    demoUrl: "https://ishaan-11.github.io/breakout-game",
    gitUrl: "https://github.com/Ishaan-11/breakout-game",
  },
  {
    heading: "Keeper_App",
    description:
      "A clone of Google Keep based on React where you can add your notes.",
    imageName: "KeeperApp",
    demoUrl: "https://ishaan11-keeper-app.netlify.app/",
    gitUrl: "https://github.com/Ishaan-11/Keeper-App",
  },

  {
    heading: "ToDoList",
    description: "A simple ToDoList using Express, ejs and mongoose.",
    imageName: "Todolist",
    demoUrl: "https://calm-hollows-04270.herokuapp.com",
    gitUrl: "",
  },
];

export { Projects };
